export default {
  table: {
    '& th': {
      textAlign: 'left'
    }
  }
}
